import styled from 'styled-components'

export const Content = styled.div`
  flex: 1;
  margin: 0 0 1.25rem 0;
`
